/**
 * Whether a model file entry is a real TFLite artifact the UI should offer
 * as a download.
 *
 * Archives named `tflite.zip` often contain only ONNX intermediates from a
 * partial export — those must not show as a TFLite download by themselves
 * (issue #38). Prefer bare `.tflite` files (uploaded when export succeeds).
 * When both bare `.tflite` and `tflite.zip` exist, prefer the zip so users
 * get the full multi-precision export (issue #64).
 */
export function isDownloadableTfliteFile(file) {
  const name = String((file && file.name) || '').toLowerCase();
  return name.endsWith('.tflite') && !name.includes('.zip');
}

export function isTfliteZipFile(file) {
  const name = String((file && file.name) || '').toLowerCase();
  return name.includes('tflite.zip');
}

/**
 * Files for the TFLite export download button.
 * Returns tflite.zip when a bare `.tflite` proves the export is real; otherwise
 * bare `.tflite` files; zip-only returns [] (issue #38).
 */
export function tfliteDownloadFiles(files) {
  const list = Array.isArray(files) ? files : [];
  const bare = list.filter(isDownloadableTfliteFile);
  if (bare.length === 0) {
    return [];
  }
  const zips = list.filter(isTfliteZipFile);
  if (zips.length > 0) {
    return zips;
  }
  return bare;
}

/**
 * LiteRT uses the same FlatBuffer `.tflite` format. Match bare `.tflite` or
 * a dedicated `litert.zip` that was produced after a successful export.
 */
export function isDownloadableLitertFile(file) {
  const name = String((file && file.name) || '').toLowerCase();
  if (name.includes('litert.zip')) {
    return true;
  }
  return name.endsWith('.tflite') && !name.includes('.zip');
}
